import { createEvent } from '@cobuildlab/react-simple-state';
import { UserType } from '../../shared/types';

export const OnUserCount = createEvent<Array<number>>();
export const OnUserError = createEvent();
export const OnUpdateUser = createEvent<UserType>();
export const OnUpdateUserError = createEvent<TypeError>();
export const OnUpdateUserAvatar = createEvent<UserType>();
export const OnUpdateUserAvatarError = createEvent<TypeError>();
